import { BreadcrumbProps } from 'packages/common-frontend/components/Breadcrumbs';
import { creditFacilityIdQueryParam } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { settingsPaths } from 'packages/sidebar/ui/sideBarUtils';

export const SettingsBreadcrumb: BreadcrumbProps = {
  label: 'Settings',
  path: settingsPaths.settings,
};

export const SettingsFacilitiesBreadcrumb: BreadcrumbProps = {
  label: 'Facilities',
  path: settingsPaths.facilities,
};

export const getSettingsPortfolioCovenantsBreadcrumb: (
  creditFacilityId: string,
) => BreadcrumbProps = (creditFacilityId) => {
  return {
    label: 'Portfolio Covenants',
    path: `${settingsPaths.facilitiesPortfolioCovenantsConfiguration}?${creditFacilityIdQueryParam}=${creditFacilityId}`,
  };
};
